<div class="container">
  <nav class="navigation">
    <div class="navigation__left">
      <div class="btn-div">
        <button class="back-btn" (click)="goBack()">
          <img src="assets/back.png" alt="">
        </button>
      </div>

      <div class="tabs">
        <div class="tab" [ngClass]="{'tab--active': selectedTab === 'userPermissions'}"
          (click)="selectTab('userPermissions')">
          <span>P2P User Permissions</span>
          <div class="active-indicator active-indicator--yellow"></div>
        </div>
        <div class="tab" [ngClass]="{'tab--active': selectedTab === 'utilityConfig'}"
          (click)="selectTab('utilityConfig')">
          <span>Utility Permissions</span>
          <div class="active-indicator active-indicator--yellow"></div>
        </div>
        <div class="tab" [ngClass]="{'tab--active': selectedTab === 'biddingType'}" (click)="selectTab('biddingType')">
          <span>Bidding type Configuration</span>
          <div class="active-indicator active-indicator--yellow"></div>
        </div>
      </div>
    </div>
    <div class="navigation__right">
      <button class="btn btn--primary" (click)="openEditUtilityModal()">Edit Utility</button>
    </div>
  </nav>

  <main class="main-content">
    <app-user-permissions *ngIf="selectedTab === 'userPermissions'"></app-user-permissions>
    <app-utility-config *ngIf="selectedTab === 'utilityConfig'"></app-utility-config>
    <app-bidding-type *ngIf="selectedTab === 'biddingType'"></app-bidding-type>
  </main>
</div>